import React, { Component } from 'react';
import './style.scss';

const angleBetweenPoints = (p1, p2) => {
  return (Math.atan2(p2.y - p1.y, p2.x - p1.x) * 180) / Math.PI;
};

export class Rotateable extends Component {
  constructor(props) {
    super(props);
    const { element } = this.props;
    this.state = { angle: element.rotate };
    this.onRotate = this.onRotate.bind(this);
    this.onRotateEnd = this.onRotateEnd.bind(this);
    this.onRotateStart = this.onRotateStart.bind(this);
  }

  onRotate = (event) => {
    const { left, top, height, width } = this.anchor.getBoundingClientRect();
    const angle = angleBetweenPoints({ x: left + width / 2, y: top + height / 2 }, { x: event.clientX, y: event.clientY });
    this.props.onRotate({ angle });
    requestAnimationFrame(() => {
      this.setState({ angle });
    });
    event.preventDefault();
    event.stopPropagation();
  };

  onRotateEnd = (event) => {
    document.removeEventListener('mousemove', this.onRotate);
    event.preventDefault();
    event.stopPropagation();
  };

  onRotateStart = (event) => {
    document.addEventListener('mousemove', this.onRotate);
    document.addEventListener('mouseup', this.onRotateEnd);
    event.preventDefault();
    event.stopPropagation();
  };

  componentDidMount() {
    this.anchor.addEventListener('mousedown', this.onRotateStart);
  }

  componentWillUnmount() {
    this.anchor.removeEventListener('mousedown', this.onRotateStart);
    document.removeEventListener('mousemove', this.onRotate);
    document.removeEventListener('mouseup', this.onRotateEnd);
  }

  render() {
    const { key, isEditable, children } = this.props;
    const { angle } = this.state;
    return (
      <div
        key={key}
        style={{
          transform: `rotate(${angle}deg)`,
        }}
        className={`rotateable ${!isEditable ? 'hidden' : ''}`}
        ref={(ref) => {
          this.rotateableRef = ref;
        }}>
        {children}
        <div
          className={'anchor'}
          ref={(ref) => {
            this.anchor = ref;
          }}
        />
      </div>
    );
  }
}
